import { API_BILLING, API_BILLING_PDF } from 'config'
import Api from 'services/api'

import { downloadFile } from './documents'

export const getBillingInvoices = () => {
  return Api.get(API_BILLING)
}

export const downloadBillingInvoicePdf = async (id: number, number: string) => {
  const res: Blob = await Api.get(API_BILLING_PDF, {}, { id }, { responseType: 'blob' })
  downloadFile(`Invoice-${number}.pdf`, res)
}
